import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
class ModalContainer extends React.Component {
    componentWillMount() {
        if (!document) {
            return;
        }
        const { className } = this.props;
        // 如果是modal_toast复用原来的el，否则新生成el
        this.el = document.createElement('div');
        const cls = classnames('cf_modal', className);
        this.el.setAttribute('class', cls);
        document.body.appendChild(this.el);
    }
    componentWillUnmount() {
        this.el && document.body.removeChild(this.el);
        document.body.style.overflow = '';
    }
    render() {
        const { visible, children } = this.props;
        if (visible) {
            this.el.classList.add('cfm_modal_open');
            document.body.style.overflow = 'hidden';
        }
        else {
            this.el.classList.remove('cfm_modal_open');
            document.body.style.overflow = '';
        }
        return <React.Fragment>
      {ReactDOM.createPortal(children, this.el)}
    </React.Fragment>;
    }
}
ModalContainer.defaultProps = {
    visible: false,
};
export default ModalContainer;



// WEBPACK FOOTER //
// ./components/modal/ModalContainer.tsx